<template>
	<md-field :class="[{ 'md-error': error }]">
		<label>{{ labelText }}</label>
		<TbSelect v-model="moduleValue"
				  @md-selected="onSelect"
				  :options="options"
				  options-value-field="key"
				  options-display-field="name"
				  :disabled="disabled"
				  :required="required"
		/>
		<span v-if="error" class="validation-error">{{ error }}</span>
	</md-field>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		labelText: { type: String },
		value: { type: String, default: "" },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" }
	},
	data() {
		return {
			moduleValue: ""
		};
	},
	mounted() {
		this.moduleValue = this.value;
	},
	computed: {
		options() {
			return Object.keys(enumDef.language.properties).map(key => {
				return {
					key: key,
					name: this.$t(enumDef.language.properties[key].key)
				};
			});
		}
	},
	methods: {
		onSelect() {
			this.$emit("input", this.moduleValue);
		},
	},
	watch: {
		value() {
			this.moduleValue = this.value;
		}
	}
};
</script>
